import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 17/10;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 17 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-434.000000, -225.000000)" fill={color}>
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(13.000000, 41.000000)">
                        <path d="M9.03710938,14 L7.50585938,14 L7.50585938,9.63183594 L2.44042969,9.63183594 L2.44042969,14 L0.909179688,14 L0.909179688,4.13574219 L2.44042969,4.13574219 L2.44042969,8.30566406 L7.50585938,8.30566406 L7.50585938,4.13574219 L9.03710938,4.13574219 L9.03710938,14 Z M11.4277344,9.01953125 C11.4277344,7.75 12.4482422,6.82226562 13.8496094,6.82226562 C15.1923828,6.82226562 16.1933594,7.67675781 16.1933594,8.79492188 C16.1933594,9.61523438 15.7539062,10.2255859 14.7236328,11.2802734 L12.9609375,13.0527344 L12.9609375,13.0771484 L16.3056641,13.0771484 L16.3056641,14 L11.4863281,14 L11.4863281,13.2578125 L14.0302734,10.6650391 C14.8896484,9.77148438 15.1142578,9.40039062 15.1142578,8.84863281 C15.1142578,8.22363281 14.5478516,7.72558594 13.8154297,7.72558594 C13.0439453,7.72558594 12.4628906,8.28222656 12.4628906,9.01464844 L12.4628906,9.02929688 L11.4277344,9.02929688 L11.4277344,9.01953125 Z" id="H2"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatHeadingTwo extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
